var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ParentPage',{staticClass:"Reporting",attrs:{"menu":_vm.setMenu,"root-route-name":_vm.rootRouteName}})
}
var staticRenderFns = []

export { render, staticRenderFns }